const ActionTypes = {
    INITIAL_FETCH_ALL_REQUEST: "INITIAL_FETCH_ALL_REQUEST",
    INITIAL_FETCH_ALL_SUCCESS: "INITIAL_FETCH_ALL_SUCCESS",
    INITIAL_FETCH_ALL_FAIL: "INITIAL_FETCH_ALL_FAIL",
    FETCH_OPTIONS_REQUEST: "FETCH_OPTIONS_REQUEST",
    FETCH_OPTIONS_SUCCESS: "FETCH_OPTIONS_SUCCESS",
    FETCH_OPTIONS_FAIL: "FETCH_OPTIONS_FAIL",
    FETCH_PAGE_REQUEST: "FETCH_PAGE_REQUEST",
    FETCH_PAGE_SUCCESS: "FETCH_PAGE_SUCCESS",
    FETCH_PAGE_FAIL: "FETCH_PAGE_FAIL",
    ADD_SUBSCRIBER_REQUEST: "ADD_SUBSCRIBER_REQUEST",
    ADD_SUBSCRIBER_SUCCESS: "ADD_SUBSCRIBER_SUCCESS",
    ADD_SUBSCRIBER_FAIL: "ADD_SUBSCRIBER_FAIL",
    FETCH_CONTENT_TAGS_REQUEST: "FETCH_CONTENT_TAGS_REQUEST",
    FETCH_CONTENT_TAGS_SUCCESS: "FETCH_CONTENT_TAGS_SUCCESS",
    FETCH_CONTENT_TAGS_FAIL: "FETCH_CONTENT_TAGS_FAIL",
    FETCH_TAGS_COUNTER_REQUEST: "FETCH_TAGS_COUNTER_REQUEST",
    FETCH_TAGS_COUNTER_SUCCESS: "FETCH_TAGS_COUNTER_SUCCESS",
    FETCH_TAGS_COUNTER_FAIL: "FETCH_TAGS_COUNTER_FAIL",
    SET_TAGS_COUNTER: "SET_TAGS_COUNTER",
    FETCH_EVENTS_REQUEST: "FETCH_EVENTS_REQUEST",
    FETCH_EVENTS_SUCCESS: "FETCH_EVENTS_SUCCESS",
    FETCH_EVENTS_FAIL: "FETCH_EVENTS_FAIL",
    FETCH_CLUBS_REQUEST: "FETCH_CLUBS_REQUEST",
    FETCH_CLUBS_SUCCESS: "FETCH_CLUBS_SUCCESS",
    FETCH_CLUBS_FAIL: "FETCH_CLUBS_FAIL",
    SET_NAV_HEIGHT: "SET_NAV_HEIGHT",
    UPDATE_CURRENT_PAGE_PATH: "UPDATE_CURRENT_PAGE_PATH",
    HIDE_NAV: "HIDE_NAV",
    SHOW_NAV: "SHOW_NAV",
    INVERT_NAV: "INVERT_NAV",
    UNINVERT_NAV: "UNINVERT_NAV",
    OPEN_ACCOUNT_MODAL: "OPEN_ACCOUNT_MODAL",
    UNOPEN_ACCOUNT_MODAL: "UNOPEN_ACCOUNT_MODAL",
    OPEN_ALERT_MODAL: "OPEN_ALERT_MODAL",
    UNOPEN_ALERT_MODAL: "UNOPEN_ALERT_MODAL",
    SET_CHECKOUT_NAV: "SET_CHECKOUT_NAV",
    UNSET_CHECKOUT_NAV: "UNSET_CHECKOUT_NAV",
    SET_SIMPLE_NAV: "SET_SIMPLE_NAV",
    UNSET_SIMPLE_NAV: "UNSET_SIMPLE_NAV",
    SET_NO_NAV: "SET_NO_NAV",
    UNSET_NO_NAV: "UNSET_NO_NAV",
    SET_PARTNER_LOGO: "SET_PARTNER_LOGO",
    UNSET_PARTNER_LOGO: "UNSET_PARTNER_LOGO",
    HIDE_SIGNUP_FOOTER: "HIDE_SIGNUP_FOOTER",
    SHOW_SIGNUP_FOOTER: "SHOW_SIGNUP_FOOTER",
    UPDATE_FILTERS_LIST: "UPDATE_FILTERS_LIST",
    UPDATE_FEATURED_LIST: "UPDATE_FEATURED_LIST",
    LOGIN_REQUEST: "LOGIN_REQUEST",
    LOGIN_FAILURE: "LOGIN_FAILURE",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    REGISTER_REQUEST: "REGISTER_REQUEST",
    REGISTER_SUCCESS: "REGISTER_SUCCESS",
    REGISTER_FAILURE: "REGISTER_FAILURE",
    NEW_LOGIN: "NEW_LOGIN",
    OKTA_REDIRECT_REQUEST: "OKTA_REDIRECT_REQUEST",
    OKTA_REDIRECT_SUCCESS: "OKTA_REDIRECT_SUCCESS",
    OKTA_REDIRECT_FAILURE: "OKTA_REDIRECT_FAILURE",
    SET_LOGIN_CALLBACK: "SET_LOGIN_CALLBACK",
    CLEAR_LOGIN_CALLBACK: "CLEAR_LOGIN_CALLBACK",
    GET_PROFILE_REQUEST: "GET_PROFILE_REQUEST",
    GET_PROFILE_SUCCESS: "GET_PROFILE_SUCCESS",
    GET_PROFILE_FAIL: "GET_PROFILE_FAIL",
    UPDATE_PROFILE_REQUEST: "UPDATE_PROFILE_REQUEST",
    UPDATE_PROFILE_SUCCESS: "UPDATE_PROFILE_SUCCESS",
    UPDATE_PROFILE_FAIL: "UPDATE_PROFILE_FAIL",
    GET_MY_MEMBERSHIPS_REQUEST: "GET_MY_MEMBERSHIPS_REQUEST",
    GET_MY_MEMBERSHIPS_FAIL: "GET_MY_MEMBERSHIPS_FAIL",
    GET_MY_MEMBERSHIPS_SUCCESS: "GET_MY_MEMBERSHIPS_SUCCESS",
    GET_PURCHASED_EVENTS_REQUEST: "GET_PURCHASED_EVENTS_REQUEST",
    GET_PURCHASED_EVENTS_SUCCESS: "GET_PURCHASED_EVENTS_SUCCESS",
    GET_PURCHASED_EVENTS_FAIL: "GET_PURCHASED_EVENTS_FAIL",
    GET_MY_OPTIN_SUCCESS: "GET_MY_OPTIN_SUCCESS",
    AUTHENTICATED: "AUTHENTICATED",
    SET_USER_NONCE: "SET_USER_NONCE",
    LOGOUT: "LOGOUT",
    SET_HISTORY_BACK: "SET_HISTORY_BACK",
    CLEAR_HISTORY_BACK: "CLEAR_HISTORY_BACK",
    SET_PREVIOUS_PAGE: "SET_PREVIOUS_PAGE",
    GET_CART_REQUEST: "GET_CART_REQUEST",
    GET_CART_SUCCESS: "GET_CART_SUCCESS",
    GET_CART_FAIL: "GET_CART_FAIL",
    CLEAR_CART: "CLEAR_CART",
    ADD_TO_CART_REQUEST: "ADD_TO_CART_REQUEST",
    ADD_TO_CART_SUCCESS: "ADD_TO_CART_SUCCESS",
    ADD_TO_CART_FAIL: "ADD_TO_CART_FAIL",
    QUICK_REG_REQUEST: "QUICK_REG_REQUEST",
    QUICK_REG_SUCCESS: "QUICK_REG_SUCCESS",
    QUICK_REG_FAIL: "QUICK_REG_FAIL",
    REMOVE_FROM_CART_REQUEST: "REMOVE_FROM_CART_REQUEST",
    REMOVE_FROM_CART_SUCCESS: "REMOVE_FROM_CART_SUCCESS",
    REMOVE_FROM_CART_FAIL: "REMOVE_FROM_CART_FAIL",
    APPLY_PROMO_REQUEST: "APPLY_PROMO_REQUEST",
    APPLY_PROMO_SUCCESS: "APPLY_PROMO_SUCCESS",
    APPLY_PROMO_FAIL: "APPLY_PROMO_FAIL",
    SELECT_SHIPPING_REQUEST: "SELECT_SHIPPING_REQUEST",
    SELECT_SHIPPING_SUCCESS: "SELECT_SHIPPING_SUCCESS",
    SELECT_SHIPPING_FAIL: "SELECT_SHIPPING_FAIL",
    UPDATE_CUSTOMER_CART_REQUEST: "UPDATE_CUSTOMER_CART_REQUEST",
    UPDATE_CUSTOMER_CART_SUCCESS: "UPDATE_CUSTOMER_CART_SUCCESS",
    UPDATE_CUSTOMER_CART_FAIL: "UPDATE_CUSTOMER_CART_FAIL",
    RESET_CHECKOUT_STEP: "RESET_CHECKOUT_STEP",
    SET_SAME_BILLING_DETAILS: "SET_SAME_BILLING_DETAILS",
    GET_PAYMENT_OPTIONS_REQUEST: "GET_PAYMENT_OPTIONS_REQUEST",
    GET_PAYMENT_OPTIONS_SUCCESS: "GET_PAYMENT_OPTIONS_SUCCESS",
    GET_PAYMENT_OPTIONS_FAIL: "GET_PAYMENT_OPTIONS_FAIL",
    CLOSE_ALL_MODALS: "CLOSE_ALL_MODALS",
};

export default ActionTypes;
